import { usePathname } from '@/i18n/navigation';
import { getCategoryTree } from '@/services/category';
import useCategoryStore from '@/store/category.store';
import { shouldShowMainLayout } from '@/utils/global';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import useSWRMutation from 'swr/mutation';

export function useCategoryTree() {
  const locale = useLocale();
  const pathname = usePathname();
  const showMainBlocks = shouldShowMainLayout(pathname);

  // states from Zustand store
  const categoryTreeData = useCategoryStore((state) => state.categoryTreeData);
  const isHydrated = useCategoryStore((state) => state._hasHydrated);

  // actions from Zustand store
  const setCategoryTree = useCategoryStore((state) => state.setCategoryTree);

  // useSWRMutation for category tree data
  const { trigger, isMutating, data, error } = useSWRMutation(
    `/api/category/tree?locale=${locale}`,
    async () => {
      const { data, error } = await getCategoryTree(locale);
      return error == null ? data : {};
    },
    {
      revalidateOnMount: false,
      revalidateOnFocus: false,
      onSuccess: (data) => {
        const savedData = {
          ...data?.data,
          // children_data: data?.data?.children_data?.filter(
          //   (e) => e?.id !== BRAND_CATEGORY_ID
          // ),
        };
        setCategoryTree({
          ...(savedData || {}),
          cacheTime: Date.now() + 30 * 60 * 1000,
          locale,
        });
      },
    }
  );

  useEffect(() => {
    // Check if locale has changed or cache has expired
    const isCacheExpired =
      !categoryTreeData?.cacheTime || categoryTreeData?.cacheTime <= Date.now();
    const isLocaleMismatch = locale !== categoryTreeData?.locale;

    // Only trigger fetch if the locale has changed or cache has expired AND fetch hasn't been triggered yet
    if (isHydrated && (isLocaleMismatch || isCacheExpired) && showMainBlocks) {
      trigger();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    locale,
    categoryTreeData?.cacheTime,
    categoryTreeData?.locale,
    isHydrated,
  ]);

  return { isMutating, data, error };
}
